import DefaultScreen from "@components/Global/DefaultScreenView"

const CompletedCourses = () => {
  return (
    <DefaultScreen>

    </DefaultScreen>
  )
}
export default CompletedCourses;